import React from 'react';
import { get, post, put, del, patch } from '../../Utility/Http';
import { userDetailsGet, userDeleteGet, resetPasswordApi, usersGet } from '../Model/UserModel';

export const user_Details = async (id) => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}users/${id}`);
    return userDetailsGet(response);
};

export const userDelete = async (data) => {
    const response = await del(`${process.env.EXTENDED_URL_WITHOUT_VERSION}users`, data);
    return userDeleteGet(response);
};

export const resetPassword = async (data) => {
    const response = await patch(`${process.env.EXTENDED_URL_WITHOUT_VERSION}users/resetpassword`, data);
    return resetPasswordApi(response);
};

export const users = async (data, id) => {
    const response = await patch(`${process.env.EXTENDED_URL_WITHOUT_VERSION}users/${id}`, data);
    return usersGet(response);
};
